import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusMacro: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFocusMacro"><Path d="M3 3H9V5H5V9H3V3Z" fill="currentColor"/><Path d="M15 3H21V9H19V5H15V3Z" fill="currentColor"/><Path d="M5 15V19H9V21H3V15H5Z" fill="currentColor"/><Path d="M21 15V21H15V19H19V15H21Z" fill="currentColor"/><Path d="M13 14.874V17H11V14.874C9.27477 14.43 8 12.8639 8 11V7.23349L10.5216 8.31419L12 6.83582L13.4784 8.31419L16 7.23349V11C16 12.8639 14.7252 14.43 13 14.874Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusMacro;
